export class AuthApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly body?: unknown,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'AuthApiError';
  }
}
